import { motion, AnimatePresence } from 'framer-motion';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

export default function ImageModal({ isOpen, image, onClose, onNext, onPrev, hasNext, hasPrev }) {
  if (!image) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />

          {/* Modal */}
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
            onClick={onClose}
          >
            <motion.div
              className="relative max-w-4xl w-full bg-white rounded-3xl overflow-hidden shadow-2xl"
              onClick={(e) => e.stopPropagation()}
              initial={{ y: 20 }}
              animate={{ y: 0 }}
              exit={{ y: 20 }}
            >
              {/* Close Button */}
              <button
                onClick={onClose}
                className="absolute top-4 right-4 z-10 p-2 rounded-full bg-white/90 hover:bg-white text-text transition-all hover:scale-110 shadow-lg"
                aria-label="Close modal"
              >
                <X size={24} />
              </button>

              {/* Previous Button */}
              {hasPrev && (
                <button
                  onClick={onPrev}
                  className="absolute left-4 top-1/2 -translate-y-1/2 z-10 p-3 rounded-full bg-white/90 hover:bg-white text-text transition-all hover:scale-110 shadow-lg hover:shadow-xl"
                  aria-label="Previous image"
                >
                  <ChevronLeft size={28} />
                </button>
              )}

              {/* Next Button */}
              {hasNext && (
                <button
                  onClick={onNext}
                  className="absolute right-4 top-1/2 -translate-y-1/2 z-10 p-3 rounded-full bg-white/90 hover:bg-white text-text transition-all hover:scale-110 shadow-lg hover:shadow-xl"
                  aria-label="Next image"
                >
                  <ChevronRight size={28} />
                </button>
              )}

              {/* Image */}
              <div className="relative overflow-hidden bg-slate-100">
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-auto max-h-[70vh] object-contain"
                />
              </div>

              {/* Caption */}
              <div className="p-6 sm:p-8 bg-white">
                <h3 className="font-display text-2xl text-text mb-2">{image.alt}</h3>
                {image.description && (
                  <p className="text-slate-600 leading-relaxed">{image.description}</p>
                )}
              </div>
            </motion.div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}

